import React from 'react';
import { IconButton } from '@mui/material';
import { Step, StepButton, Stepper } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styled from 'styled-components';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import { campaignBuilderStepCount, getCampaignBuilderStepKey } from './campaignBuilderUtils';

const StepperRow = styled.div`
    display: flex;
    align-items: center;
    gap: var(--spacer-S);
`;

export interface CampaignBuilderStepperProps {
    activeStep: number;
    canGoBack: boolean;
    canGoNext: boolean;
    loading: boolean;
    onBack: () => void;
    onNext: () => void;
    onStepClick: (step: number) => void;
}

export const CampaignBuilderStepper: React.FC<CampaignBuilderStepperProps> = ({
    activeStep,
    canGoBack,
    canGoNext,
    loading,
    onBack,
    onNext,
    onStepClick,
}) => {
    const t = useTranslations();

    return (
        <StepperRow>
            <IconButton disabled={!canGoBack || loading} onClick={onBack} size="small">
                <ChevronLeftIcon />
            </IconButton>
            <div style={{ flex: 1 }}>
                <Stepper activeStep={activeStep - 1} alternativeLabel nonLinear>
                    {Array.from({ length: campaignBuilderStepCount }, (_, index) => {
                        const step = index + 1;

                        return (
                            <Step key={step} completed={step < activeStep}>
                                <StepButton
                                    onClick={() => onStepClick(step)}
                                    disabled={step > activeStep + 1 || loading}
                                >
                                    {t(getCampaignBuilderStepKey(step))}
                                </StepButton>
                            </Step>
                        );
                    })}
                </Stepper>
            </div>
            <IconButton disabled={!canGoNext || loading} onClick={onNext} size="small">
                <ChevronRightIcon />
            </IconButton>
        </StepperRow>
    );
};
